export default "__VITE_ASSET__tkj5vR$4__"